import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PeriodeData } from 'src/app/class/datatype';
import { CASHIER_STORAGE_KEYS } from 'src/app/services/cashier/cashier-storage';
import { CashierStudent } from './cashier.models';

/**
 * Periode terpilih dan siswa yang sedang dibayar, disimpan di sessionStorage supaya tetap ada
 * setelah refresh halaman. Dihapus saat logout (AuthService.clearAuthData).
 */
@Injectable({ providedIn: 'root' })
export class CashierStateService {
  private readonly periodeSubject = new BehaviorSubject<PeriodeData | null>(
    this.read<PeriodeData>(CASHIER_STORAGE_KEYS.periode)
  );

  /** Periode kasir saat ini; header kasir menulisnya, halaman pencarian membacanya. */
  readonly periode$: Observable<PeriodeData | null> = this.periodeSubject.asObservable();

  get periode(): PeriodeData | null {
    return this.read<PeriodeData>(CASHIER_STORAGE_KEYS.periode);
  }

  set periode(value: PeriodeData | null) {
    this.write(CASHIER_STORAGE_KEYS.periode, value);
    this.periodeSubject.next(value);
  }

  /** Membaca ulang dari sessionStorage, mis. setelah logout lalu login sebagai kasir lain. */
  sync(): void {
    this.periodeSubject.next(this.periode);
  }

  get student(): CashierStudent | null {
    return this.read<CashierStudent>(CASHIER_STORAGE_KEYS.student);
  }

  set student(value: CashierStudent | null) {
    this.write(CASHIER_STORAGE_KEYS.student, value);
  }

  private read<T>(key: string): T | null {
    try {
      const raw = window.sessionStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  }

  private write(key: string, value: unknown): void {
    try {
      if (value === null || value === undefined) {
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, JSON.stringify(value));
      }
    } catch {
      // sessionStorage bisa tidak tersedia; layar tetap jalan tanpa penyimpanan.
    }
  }
}
